import type { AudioPlayer } from "./AudioPlayer.ts"

import * as React from "react"

export function useMediaSession(
  track: AudioPlayer.CurrentTrack | null,
  artworkUrl: string | null,
  handlers: {
    onPlay?: () => void
    onPause?: () => void
    onNext?: () => void
    onPrevious?: () => void
  }
) {
  React.useEffect(() => {
    if (!track || !("mediaSession" in navigator)) return

    navigator.mediaSession.metadata = new MediaMetadata({
      title: track.title,
      artist: track.artist,
      artwork: artworkUrl ? [{ src: artworkUrl }] : []
    })

    navigator.mediaSession.setActionHandler("play", handlers.onPlay ?? null)
    navigator.mediaSession.setActionHandler("pause", handlers.onPause ?? null)
    navigator.mediaSession.setActionHandler("nexttrack", handlers.onNext ?? null)
    navigator.mediaSession.setActionHandler("previoustrack", handlers.onPrevious ?? null)

    return () => {
      navigator.mediaSession.setActionHandler("play", null)
      navigator.mediaSession.setActionHandler("pause", null)
      navigator.mediaSession.setActionHandler("nexttrack", null)
      navigator.mediaSession.setActionHandler("previoustrack", null)
    }
  }, [track, artworkUrl])
}
